<nz-collapse class="mb-xs">
  <ng-template #header2>
    <div class="tw-flex tw-items-center tw-h-4">
      <img src="./../../../../assets/images/icons/icons8-schedules-100.png" alt="" class="tw-w-6 tw-mr-3">
      <p class="tw-text-gray-700 tw-text-sm tw-uppercase">
        Tienes 5 solicitudes de cita
      </p>
    </div>
  </ng-template>
  <nz-collapse-panel [nzHeader]="header2">
    <p class="text-info tw-mb-3">Los usuarios han solicitado una cita contigo, puedes aceptar o rechazar las solicitudes. Se le notificará al usuario.</p>
    <div class="cards-appointment-request">
      <app-card-appointment-request></app-card-appointment-request>
      <app-card-appointment-request></app-card-appointment-request>
      <app-card-appointment-request></app-card-appointment-request>
      <app-card-appointment-request></app-card-appointment-request>
      <app-card-appointment-request></app-card-appointment-request>
    </div>
  </nz-collapse-panel>
</nz-collapse>
